import React, { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { useAuth } from '../contexts/AuthContext';
import { useQuery } from '@apollo/client';
import { GET_TODAY_FIELD_TECHNICIAN_MAP_LOCATIONS } from '../graphql/gps-tracking';
import GPSTrackingMapView from '../components/gps-tracking/GPSTrackingMapView';

export default function GPSTracking() {
  const navigate = useNavigate();
  const { user: currentUser, loading: authLoading } = useAuth();

  useEffect(() => {
    if (!authLoading && !currentUser) {
      navigate('/login');
      return;
    }

    if (currentUser) {
      const allowedRoles = ['ADMIN', 'PROPERTY_MANAGER', 'HOUSEKEEPER_MANAGER', 'CALL_CENTER'];
      if (!allowedRoles.includes(currentUser.role)) {
        navigate('/dashboard');
        return;
      }
    }
  }, [currentUser, authLoading, navigate]);

  const { data: mapData, loading: mapLoading, refetch: refetchMap } = useQuery(
    GET_TODAY_FIELD_TECHNICIAN_MAP_LOCATIONS,
    {
      pollInterval: 30000,
      fetchPolicy: 'cache-and-network',
    },
  );

  if (authLoading) {
    return (
      <div className="flex justify-center items-center min-h-[200px]">
        <div className="text-gray-500">Loading...</div>
      </div>
    );
  }

  return (
    <div className="-mx-2 md:-mx-4 lg:-mx-8 -my-2 md:-my-4">
      <GPSTrackingMapView
        entries={mapData?.todayFieldTechnicianMapLocations || []}
        loading={mapLoading}
        refetch={refetchMap}
      />
    </div>
  );
}
